import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const BatteryIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 10.758 14.953">
      <g transform="translate(19185.25 4168.561)">
        <g transform="translate(-19185 -4168.311)">
          <path
            d="M108.282,1.461h.34V1.127A1.022,1.022,0,0,1,109.643.106h4.083a1.022,1.022,0,0,1,1.021,1.021v.334h.34a1.7,1.7,0,0,1,1.7,1.7V5.2a.34.34,0,0,1-.68,0V3.162a1.022,1.022,0,0,0-1.021-1.021h-.68a.34.34,0,0,1-.34-.34V1.127a.34.34,0,0,0-.34-.34h-4.083a.34.34,0,0,0-.34.34V1.8a.34.34,0,0,1-.34.34h-.68a1.022,1.022,0,0,0-1.021,1.021v3.4a.34.34,0,0,1-.68,0v-3.4A1.7,1.7,0,0,1,108.282,1.461Z"
            transform="translate(-106.581 -0.106)"
            fill={props.color || theme.palette.secondary.main}
            stroke={props.color || theme.palette.secondary.main}
            strokeWidth="0.5"
          />
          <path
            d="M106.958,296.273a.34.34,0,0,1,.34.34v6.879a1.022,1.022,0,0,0,1.021,1.021h6.8a1.022,1.022,0,0,0,1.021-1.021v-8.92a.34.34,0,0,1,.68,0v8.92a1.7,1.7,0,0,1-1.7,1.7h-6.8a1.7,1.7,0,0,1-1.7-1.7v-6.879A.34.34,0,0,1,106.958,296.273Z"
            transform="translate(-106.567 -290.739)"
            fill={props.color || theme.palette.secondary.main}
            stroke={props.color || theme.palette.secondary.main}
            strokeWidth="0.5"
          />
        </g>
        <line
          x2="3.188"
          transform="translate(-19181.535 -4157.487)"
          fill="none"
          stroke={props.color || theme.palette.secondary.main}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          x2="3.188"
          transform="translate(-19181.535 -4160.258)"
          fill="none"
          stroke={props.color || theme.palette.secondary.main}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          x2="3.188"
          transform="translate(-19181.535 -4163.03)"
          fill="none"
          stroke={props.color || theme.palette.secondary.main}
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </SvgIcon>
  );
};
